import TomSelect from 'tom-select';

import businessIcon from '../icons/briefcase.svg';
import eventsIcon from '../icons/events.svg';
import conferenceIcon from '../icons/message-lines.svg';
import weddingIcon from '../icons/rings-wedding.svg';
import otherIcon from '../icons/umbrella-beach.svg';
import constructionIcon from '../icons/user-helmet-safety.svg';
import sportsIcon from '../icons/volleyball.svg';

type tripTypeOption = {
  id: string;
  icon: string;
  label: string;
};

const initTripTypePicker = () => {
  const tripTypeEl = document.querySelector<HTMLInputElement>('[data-el="trip_type"]');
  if (!tripTypeEl) return;
  const preselectValue = tripTypeEl.dataset.preselect;

  new TomSelect(tripTypeEl, {
    valueField: 'id',
    labelField: 'label',
    searchField: ['label'],
    plugins: ['restore_on_backspace'],
    options: [
      { id: 'construction_crew', label: 'Construction/Crew', icon: constructionIcon },
      { id: 'corporate_business', label: 'Corporate/Business', icon: businessIcon },
      { id: 'convention_conference', label: 'Convention/Conference', icon: conferenceIcon },
      { id: 'sports', label: 'Sports', icon: sportsIcon },
      { id: 'events', label: 'Events', icon: eventsIcon },
      { id: 'wedding', label: 'Wedding', icon: weddingIcon },
      { id: 'other', label: 'Other', icon: otherIcon },
    ],
    items: preselectValue ? [preselectValue] : [],
    render: {
      option: function (data: tripTypeOption, escape: (message: string) => string) {
        return `
        <div class="event_options">
          ${data.icon}
          <span>${escape(data.label)}</span>
        </div>`;
      },
      item: function (data: tripTypeOption, escape: (message: string) => string) {
        return `
        <div class="event_options">
          ${data.icon}
          <span>${escape(data.label)}</span>
        </div>`;
      },
    },
  });
};

export default initTripTypePicker;
